import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { log } from '../../../services/utils';

import Actions from '../Actions';

import styles from './section-header.module.css';

const SectionHeader = ( {
	actions,
	className = '',
	title
} ) => {
	return (
		<div className={ `${ styles.sectionHeader } ${ className }` }>
			<h2>
				{ log( '- sectionHeader' ) }
				{ title }
			</h2>
			<Actions actions={ actions } />
		</div>
	);
};

SectionHeader.propTypes = {
	actions: PropTypes.arrayOf( PropTypes.shape( {
		action: PropTypes.oneOfType( [
			PropTypes.func,
			PropTypes.object
		] ),
		disable: PropTypes.bool,
		icon: PropTypes.string,
		text: PropTypes.string
	} ) ),
	className: PropTypes.string,
	title: PropTypes.node
};

export default memo( SectionHeader );
